import { Button } from 'react-bootstrap';
import { IoKeyOutline } from 'react-icons/io5';
import UserMenuPanel from 'features/UserMenu/components/UserMenuPanel/UserMenuPanel';
import '../../../../assets/account.scss';

const ChangePasswordForm = ({
  children,
  submit,
  error,
  isSubmitting,
  hasSucceeded,
  onBack,
  isClassic,
}) => (
  <div className="user-menu-page" data-appearance={isClassic ? 'classic' : 'merlin'}>
    <UserMenuPanel
      icon={<IoKeyOutline />}
      title="Change Password"
      actions={
        !hasSucceeded && (
          <Button variant="secondary" onClick={onBack}>
            Back
          </Button>
        )
      }
    >
      {hasSucceeded ? (
        <>
          <p className="user-menu-status mb-0" data-tone="success" role="status">
            Password Update Successful
          </p>
          <Button
            variant={isClassic ? 'secondary' : 'primary'}
            className="align-self-start"
            onClick={onBack}
          >
            Return to Account
          </Button>
        </>
      ) : (
        <form onSubmit={submit} className="d-flex flex-column gap-3" aria-label="Change Password">
          <fieldset disabled={isSubmitting} className="d-flex flex-column gap-2 w-100 max-w-md">
            {children}
          </fieldset>
          <div className="user-menu-actions">
            <p className="user-menu-status" data-tone="error" role="status">
              {error}
            </p>
            <Button
              variant={isClassic ? 'secondary' : 'primary'}
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Updating Password…' : 'Update Password'}
            </Button>
          </div>
        </form>
      )}
    </UserMenuPanel>
  </div>
);

export default ChangePasswordForm;
